export default __webpack_public_path__ + "static/media/eb-ultra-blk-banner-1.0c6d980b.jpg";